export default __webpack_public_path__ + "static/media/335.1ad49017.png";